<template>
  <div class="service-role-add-edit">
    <div class="service-role-add-edit-module module-item-style">
      <p class="service-role-label"><span>*</span>角色名称：</p>
      <input class="service-role-input" v-model="roleName" placeholder="请输入角色名称" type="text">
    </div>
    <div class="service-role-add-edit-module module-item-style">
      <div class="select-container">
        <p class="service-role-label"><span>*</span>角色菜单：</p>
        <tree-table :menuData="menuData" :level="1"></tree-table>
      </div>
    </div>
    <div class="service-role-add-edit-module module-item-style" v-if="false">
      <div style="width: 100%;">
        <p class="service-role-label"><span>*</span>角色权限：</p>
        <el-checkbox v-model="checkAll" @change="handleCheckAllChange" class="auth-select-all">全选</el-checkbox>
        <el-checkbox-group v-model="checkedAuth" @change="handleCheckedAuthChange" class="auth-container">
          <table>
            <tbody>
            <tr v-for="(Item, itemIndex) in authData">
              <td v-for="(authItem, index) in Item">
                <el-checkbox :label="authItem.permissionsId" :key="authItem.permissionsId" :checked="authItem.isCheck == 1 ? true : false" class="auth-item">{{authItem.permissionDes}}</el-checkbox>
              </td>
            </tr>
            </tbody>
          </table>
        </el-checkbox-group>
      </div>
    </div>

    <div class="service-role-operation-container module-item-style" :class="!isCollapse ? 'to210' : 'to64'">
      <span class="wl-btn" @click="saveAddRole">保存</span>
      <span class="wl-btn-cancel" @click="cancelAddRole">取消</span>
    </div>

  </div>
</template>

<script>
  import treeTable from './components/checkbox'

  export default {
    name: 'service-role-add-edit',
    data() {
      return {
        checkAll: false,
        roleName: '',
        menuData: [],
        authData: [],
        checkedAuth: []
      }
    },
    computed:{
      isCollapse() {
        return this.$store.state.app.sidebar.clapse
      },
    },
    components: {
      treeTable
    },
    created() {
      let routeName = this.$route.name
      if (routeName == 'serviceRoleSettingAdd') {
        this.getAddRoleData()
      } else if (routeName == 'serviceRoleSettingEdit') {
        this.getEditRoleData()
      }

    },
    mounted() {

    },
    methods: {
      handleCheckAllChange(val) {
        if (val) {
          this.authData.map(item => {
            item.map(auth => {
              this.checkedAuth.push(auth.permissionsId)
            })
          })
        } else {
          this.checkedAuth = [];
        }

      },
      /**
       *
       * 选择权限
       * */
      handleCheckedAuthChange(value) {
        let checkedCount = value.length;
        let checkedArr = []
        this.authData.map(item => {
          item.map(auth => {
            checkedArr.push(auth.permissionsId)
          })
        })

        this.checkAll = checkedCount === checkedArr.length;
      },
      /**
       * 添加角色
       * */
      addRoleAjax(postData) {
        this.$http.addRoleAPI(postData).then(res => {

          if(res.status == 1){
            this.$message({
              message: ' 角色添加成功',
              type: 'success'
            })
            this.$nextTick(() => {
              this.$router.push({
                path:'/service-role-list'
              })
            })

          }
        }).catch( err => {
          console.log(err)
        })
      },
      /**
       *
       * 编辑保存角色
       * */
      editRoleSave(postData){
        this.$http.eidtRoleAPI(postData).then( res => {
          if(res.status == 1){
            this.$message({
              message: ' 角色修改成功',
              type: 'success'
            })
            this.$nextTick(() => {
              this.$router.push({
                path:'/service-role-list'
              })
            })

          }
        })
      },
      /**
       * 添加角色-获取数据
       */
      getAddRoleData() {
        this.$http.addRoleDataAPI().then(res => {
          if (res.status == 1) {
            let menu =  res.data.menuList
            // menu.map((item, i) => {
            //   if(item.path == 'customerMode'){
            //     menu.splice(i,1)
            //   }
            // })
            this.menuData = menu

            let auth = res.data.funcPermissionList
            var newRes = []
            var chunk = 4 // 将原数组拆成4个一组

            for (let i = 0, j = auth.length; i < j; i += chunk) {
              newRes.push(auth.slice(i, i + chunk));
            }
            this.authData = newRes

          }
        }).catch(err => {
          console.log(err)
        })
      },
      /**
       * 编辑角色-获取数据
       */
      getEditRoleData() {
        let postEditData = {
          roleId:this.$route.query.roleId
        }
        this.$http.editRoleDataAPI(postEditData).then(res => {

          if (res.status == 1) {
            let menu =  res.data.menuList
            // menu.map((item, i) => {
            //   if(item.path == 'customerMode'){
            //     menu.splice(i,1)
            //   }
            // })
            this.menuData = menu
            let auth = res.data.functionPermission
            let newRes = []
            let chunk = 4 // 将原数组拆成4个一组

            for (let i = 0, j = auth.length; i < j; i += chunk) {
              newRes.push(auth.slice(i, i + chunk));
            }
            this.authData = newRes
            this.roleName = res.data.roleData.roleName

            let checkedLength = 0
            auth.map( item => {
              if(item.isCheck == 1){
                checkedLength++
              }
            })
            if(checkedLength == auth.length){
              this.checkAll = true
            }else {
              this.checkAll = false
            }
          }
        }).catch(err => {
          console.log(err)
        })
      },
      saveAddRole() {
        let obj = document.getElementsByName("menuSelected");
        let check_val = [];
        for (let k in obj) {
          if (obj[k].checked) {
            check_val.push(obj[k].value);
          }
        }
        if (this.roleName.length == 0) {
          this.$message({
            message: ' 请输入角色名称',
            type: 'error'
          })
          return false
        }
        if (check_val.length == 0) {
          this.$message({
            message: ' 请选择菜单',
            type: 'error'
          })
          return false
        }
        // if (this.checkedAuth.length == 0) {
        //   this.$message({
        //     message: ' 请选择权限',
        //     type: 'error'
        //   })
        //   return false
        // }
        let postRoleData
        let routeName = this.$route.name
        if (routeName == 'serviceRoleSettingAdd') {
          postRoleData = {
            roleName: this.roleName,
            menuIds: check_val,
            funcCodeIds: this.checkedAuth
          }
          this.addRoleAjax(postRoleData)
        } else if (routeName == 'serviceRoleSettingEdit') {
          postRoleData = {
            roleId: this.$route.query.roleId,
            roleName: this.roleName,
            menuIds: check_val,
            funcCodeIds: this.checkedAuth
          }
          this.editRoleSave(postRoleData)
        }



      },
      cancelAddRole() {
        this.$router.push({
          path:'/service-role-list'
        })
      }
    }
  }
</script>

<style lang="scss">
  .service-role-add-edit {
    position: relative;
    padding-bottom: 20px;

    .service-role-add-edit-module {
      display: flex;
      margin-bottom: 10px;

      .service-role-label {
        font-size: 14px;
        color: #333;
        font-weight: bold;
        line-height: 40px;

        span {
          font-weight: normal;
          color: #ff4e00;
          padding-right: 13px;
        }

      }

      .service-role-input {
        background-color: #ffffff;
        border: solid 1px #e0e0e0;
        border-radius: $mainBorderRadius;
        height: 40px;
        width: 240px;
        outline: none;
        padding: 0 10px;
        font-size: 14px;
      }

      .select-container {
        width: 100%;
      }


      .auth-container {
        $borderColor: #ebeef5;
        width: 100%;

        table {
          border: 1px solid $borderColor;
          width: 100%;
          border-collapse: collapse;

          tr {
            line-height: 45px;

            &:nth-child( 2n + 1 ) {
              background-color: #f8f8f8;
            }

            td {
              padding: 0 20px;
              border: 1px solid $borderColor;
              width: 25%;
              box-sizing: border-box;
            }
          }
        }
      }

      .auth-select-all {
        padding: 0 0 20px 0;
      }

    }

    .service-role-operation-container {
      text-align: center;
      position: fixed;
      bottom: 0;
      right: 0;
      z-index: 999;
      border-radius: 0;
      &.to210{
        left: 210px;
      }
      &.to64{
        left: 64px;
      }
      span + span {
        margin-left: 15px;
      }
    }
  }
</style>
